
export const AUTOMOTIVE_FRR_RAR = 'AUTOMOTIVE_FRR_RAR'

export const AutomotiveScenarioTypes = [
  AUTOMOTIVE_FRR_RAR
]
